import { Injectable, inject, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SearchModalComponent } from './search-modal.component';

@Injectable({ providedIn: 'root' })
export class MenuSpotlightService implements OnDestroy {
  private readonly dialog = inject(MatDialog);
  private dialogRef: MatDialogRef<SearchModalComponent> | null = null;
  private readonly onKeyDown = (event: KeyboardEvent): void => {
    const isMod = event.ctrlKey || event.metaKey;
    if (!isMod) {
      return;
    }

    const key = event.key.toLowerCase();
    const isSpace = event.code === 'Space' || key === ' ';
    const isK = key === 'k';

    if (!isSpace && !isK) {
      return;
    }

    // Avoid firing while composing IME text.
    if (event.isComposing) {
      return;
    }

    event.preventDefault();
    this.toggle();
  };

  constructor() {
    if (typeof document !== 'undefined') {
      document.addEventListener('keydown', this.onKeyDown, true);
    }
  }

  ngOnDestroy(): void {
    if (typeof document !== 'undefined') {
      document.removeEventListener('keydown', this.onKeyDown, true);
    }
  }

  open(): void {
    if (this.dialogRef) {
      return;
    }

    this.dialogRef = this.dialog.open(SearchModalComponent, {
      panelClass: ['vex-dialog-glossy', 'menu-spotlight-dialog'],
      width: '100%',
      maxWidth: '560px',
      autoFocus: 'input',
      restoreFocus: true
    });

    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }

  toggle(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      return;
    }
    this.open();
  }
}
